"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stellar_sdk_1 = require("stellar-sdk");
const cryptoService_1 = require("./cryptoService");
exports.convertStellarAddressToRivine = (pair) => {
    throw new Error('not implemented yet');
    //back to rivine
    const stellarAddress = pair.publicKey();
    const decodedStellarPK = stellar_sdk_1.StrKey.decodeEd25519PublicKey(stellarAddress);
    cryptoService_1.encodeHex(decodedStellarPK);
    // rivineFromstellarUnlockHash, err := StrKey.NewEd25519PubKeyUnlockHash(rivinePublicKey)
    // if err != nil {
    //     panic("ERROR generating the rivine unlockhash from the decoded stellar address")
    // }
    // fmt.Println("Rivine address from Stellar address:", rivineFromstellarUnlockHash.String())
    //     return rivineFromstellarUnlockHash
};
//# sourceMappingURL=rivineService.js.map